import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { commonURI } from "../CommonUrlList/CommonUrlList";
import { DecryptOrderFunctionMaster, decryptAES256 } from "./CryptoJsService";

const filterFun = async (res) => {
    const filteredData = res.filter((val) => (val.stMarketName === "Match Odds"))
    sessionStorage.setItem("mid", (filteredData.map(a => a.stMarketID)))
    return filteredData
}

const filterEvent = async (res) => {
    const filteredData = res.filter((val) => (val.stMarketName === "Match Odds"))
    sessionStorage.setItem("mid", (filteredData.map(a => a.stMarketID)))
    const fancyFData = res.filter((val) => (val.stMarketName !== "Match Odds"))
    sessionStorage.setItem("fmid", (fancyFData.map(a => a.stMarketID)))
    return res
}

export const fetchCricketM = createAsyncThunk("fetchCricketM", async () => {
    // const headers = { 'signature': 'czPfKoYzt5iJ3RJpi81qHQ==' };
    const res = await fetch(commonURI.__MASTERREQUESTJSON_URL_HorseMain)
    // , { method: "POST", headers: headers, body: {} })
    const data = await res.json()
    const decryptData = JSON.parse(decryptAES256(data, "U2FsdGVkX1+Zdq/7v1tYigFUbuuWOOv9aNCYdBlS1BM="))
    return filterFun(decryptData)
})

export const fetchWinnerM = createAsyncThunk("fetchWinnerM", async () => {
    // const headers = { 'signature': 'czPfKoYzt5iJ3RJpi81qHQ==' };
    const res = await fetch(commonURI.__MASTERREQUESTJSON_URL_Winner)
    // , { method: "POST", headers: headers, body: {} })
    const data = await res.json()
    const decryptData = JSON.parse(decryptAES256(data, "U2FsdGVkX1+Zdq/7v1tYigFUbuuWOOv9aNCYdBlS1BM="))
    return (decryptData)
})

export const fetchWholeMaster = createAsyncThunk("fetchWholeMaster", async () => {
    const headers = { 'signature': 'czPfKoYzt5iJ3RJpi81qHQ==' };
    const res = await fetch(commonURI.__MASTERREQUESTJSON_URL, { method: "POST", headers: headers, body: {} })
    const data = await res.json()
    const decryptData = JSON.parse(DecryptOrderFunctionMaster(data, "U2FsdGVkX1+Zdq/7v1tYigFUbuuWOOv9aNCYdBlS1BM="))
    return filterFun(decryptData)
})

export const fetchInPlayMaster = createAsyncThunk("fetchInPlayMaster", async () => {
    const res = await fetch(commonURI.__MASTERREQUESTJSON_URL_INPLAY)
    const data = await res.json()
    const decryptData = JSON.parse(decryptAES256(data))
    return filterFun(decryptData)
})

export const fetchHorseMaster = createAsyncThunk("fetchHorseMaster", async () => {
    const headers = { 'signature': 'czPfKoYzt5iJ3RJpi81qHQ==' };
    const res = await fetch(commonURI.__MASTERREQUESTJSON_URL_Horse, { method: "POST", headers: headers, body: {} })
    const data = await res.json()
    const decryptData = JSON.parse(DecryptOrderFunctionMaster(data, "U2FsdGVkX1+Zdq/7v1tYigFUbuuWOOv9aNCYdBlS1BM="))
    return (decryptData)
})

export const fetchSoccerM = createAsyncThunk("fetchSoccerM", async () => {
    // const headers = { 'signature': 'czPfKoYzt5iJ3RJpi81qHQ==' };
    const res = await fetch(commonURI.__MASTERREQUESTJSON_URL_Soccer)
    // , { method: "POST", headers: headers, body: {} })
    const data = await res.json()
    const decryptData = JSON.parse(decryptAES256(data))
    return filterFun(decryptData)
})

export const fetchTennisM = createAsyncThunk("fetchTennisM", async () => {
    // const headers = { 'signature': 'czPfKoYzt5iJ3RJpi81qHQ==' };
    const res = await fetch(commonURI.__MASTERREQUESTJSON_URL_Tennis)
    // , { method: "POST", headers: headers, body: {} })
    const data = await res.json()
    const decryptData = JSON.parse(decryptAES256(data))
    return filterFun(decryptData)
})

export const fetchEventMasterWise = createAsyncThunk("fetchEventMasterWise", async () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const eventID = queryParameters.get('eventId')
    if (eventID === '' || eventID === null) {
        return []
    }
    // const headers = { 'signature': 'czPfKoYzt5iJ3RJpi81qHQ==' };
    // const res = await fetch(commonURI.__MASTERREQUESTJSON_URL_Event + "?stEventID=" + eventID, { method: "POST", headers: headers, body: {} })
    const res = await fetch(commonURI.__MASTERREQUESTJSON_URL_Event + eventID)
    const data = await res.json()
    const decryptData = JSON.parse(decryptAES256(data, "U2FsdGVkX1+Zdq/7v1tYigFUbuuWOOv9aNCYdBlS1BM="))
    return filterEvent(decryptData)
})

export const fetchPriceRate = createAsyncThunk("fetchPriceRate", async () => {
    var marketData = sessionStorage.getItem("mid")
    var marketData2 = sessionStorage.getItem("fmid")
    const headers = { 'signature': 'czPfKoYzt5iJ3RJpi81qHQ==', 'Content-Type': 'application/json' };
    const res = await fetch(commonURI._LiveJsonRate_New + "?data=" + marketData + "," + marketData2)
    // , {
    //     method: "GET"
    //     // body: JSON.stringify({ mid: marketData })
    // })
    const marketRate = await res.json()
    // const data = JSON.parse(decryptAES256(marketRate, "U2FsdGVkX1840vK+w1JNNlMdZkV1OZhTyazbJ9lll3k="))
    const data = JSON.parse(decryptAES256(marketRate.data))
    return data
})

export const fetchHomePriceRate = createAsyncThunk("fetchHomePriceRate", async () => {
    var marketData = sessionStorage.getItem("mid")
    // const headers = { 'signature': 'czPfKoYzt5iJ3RJpi81qHQ==', 'Content-Type': 'application/json' };
    const res = await fetch(commonURI._LiveJsonRate_New + "?data=" + marketData)
    //     , {
    //     method: "POST",
    //     headers: headers,
    //     body: JSON.stringify({ mid: marketData })
    // })
    const marketRate = await res.json()
    const data = JSON.parse(decryptAES256(marketRate.data))
    // const data = JSON.parse(decryptAES256(marketRate.data))
    return data
})

export const fetchFancyPriceRate = createAsyncThunk("fetchFancyPriceRate", async () => {
    return
})

export const fetchHorseNav = createAsyncThunk("fetchHorseNav", async (t) => {
    const res = await fetch(commonURI.__MASTERREQUESTJSON_URL_Horse2 + t)
    const data = await res.json()
    const decryptData = JSON.parse(decryptAES256(data))
    return decryptData
})

export const fetchHorseC = createAsyncThunk("fetchHorseC", async (coun) => {
    const res = await fetch(commonURI.__MASTERREQUESTJSON_URL_Horse_C + coun.split("|")[0] + "&dt=" + coun.split("|")[1])
    const data = await res.json()
    const decryptData = JSON.parse(decryptAES256(data))
    return decryptData
})

const homeState = createSlice({
    name: "master",
    initialState: {
        navmaster: undefined,
        master: undefined,
        priceRate: undefined,
        fpriceRate: undefined,
        loader: false,
        pricebtn: []
    },
    reducers: {
        loaderStart: (state) => {
            state.loader = true
        },
        loaderStop: (state) => {
            state.loader = false
        },
        clearMaster: (state) => {
            state.master = undefined
        },
        addpricebtn: (state, action) => {
            if (state.pricebtn.length == 0) {
                state.pricebtn = [action.payload]


            } else {
                const newpricebtn = state.pricebtn.filter((item, index) => (
                    item.stMarketID != action.payload?.stMarketID
                ))
                newpricebtn.push(action.payload)
                state.pricebtn = newpricebtn
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCricketM.fulfilled, (state, action) => {
            state.master = action.payload
        });
        builder.addCase(fetchWholeMaster.fulfilled, (state, action) => {
            state.master = action.payload
        });
        builder.addCase(fetchPriceRate.fulfilled, (state, action) => {
            state.priceRate = action.payload
        });
        builder.addCase(fetchFancyPriceRate.fulfilled, (state, action) => {
            state.fpriceRate = action.payload
        });
        builder.addCase(fetchHomePriceRate.fulfilled, (state, action) => {
            state.priceRate = action.payload
        });
        builder.addCase(fetchSoccerM.fulfilled, (state, action) => {
            state.master = action.payload
        });
        builder.addCase(fetchTennisM.fulfilled, (state, action) => {
            state.master = action.payload
        });
        builder.addCase(fetchEventMasterWise.fulfilled, (state, action) => {
            if (action.payload.length == 0) {
                return
            } else {
                state.master = action.payload
            }
        });
        builder.addCase(fetchHorseMaster.fulfilled, (state, action) => {
            state.master = action.payload
        });
        builder.addCase(fetchInPlayMaster.fulfilled, (state, action) => {
            state.master = action.payload
        });
        builder.addCase(fetchHorseNav.fulfilled, (state, action) => {
            state.navmaster = action.payload
        });
        builder.addCase(fetchHorseC.fulfilled, (state, action) => {
            state.master = action.payload
        });
        builder.addCase(fetchWinnerM.fulfilled, (state, action) => {
            state.master = action.payload
        });
    }
})

export const { loaderStart, loaderStop, clearMaster, addpricebtn } = homeState.actions

export default homeState.reducer